module.exports = __webpack_public_path__ + "static/media/logo_min.270d7bc1.svg";